import _ from 'lodash'
import NumericFilter from 'scoreboard/reports/common/filter/numeric-filter'
import Sorter from 'scoreboard/components/sorter'

//list of values that require no user input
var noValueOperators = {
	'is-na' : 'report.criteria.pretty.metricValueType.IS_NA',
	'is-yes' : 'report.criteria.pretty.metricValueType.IS_YES',
	'is-no' : 'report.criteria.pretty.metricValueType.IS_NO'
}

/** An extension of a numeric filter that include values specific to the
 *  actual value of a metric (e.g. blank, N/A, yes, no)
 */
var ActualValueFilter = NumericFilter.extend({

	initialize: function(options) {
		let opts = _.cloneDeep(options)
		opts.additionalOperators = noValueOperators
		NumericFilter.prototype.initialize.call(this, opts)
	},

	_requiresNoUserValues: function() {
		return !_.isNil(noValueOperators[this._operatorSelect().val()])
	},

	//toggles display of extra input depending on operator selection
	_onChangeOperator: function() {
		if (this._requiresNoUserValues()) {
			_.invokeMap(this._markedFields, 'clearError')
		}
		this.$('.text-wrapper').toggleClass('is-not-displayed', this._requiresNoUserValues())
		NumericFilter.prototype._onChangeOperator.apply(this)
	},

	gather: function() {
		var data = NumericFilter.prototype.gather.apply(this)
		if (this._requiresNoUserValues()) {
			data.value1 = null
			data.value2 = null
			data.values = []
		}
		return data
	}

})

export default ActualValueFilter

ActualValueFilter.__filename__ = 'reports/wizard/filter-meta/actual-value-filter.js'
